type Rotation = 0 | 90 | 180 | 270;

const NEXT_ROTATION: Record<Rotation, Rotation> = { 0: 90, 90: 180, 180: 270, 270: 0 };

const ROTATION_CLASS_NAME: Record<Rotation, string> = {
  0: '',
  90: 'rotate-90',
  180: 'rotate-180',
  270: '-rotate-90',
};

const rotateClockwise = (rotation: Rotation): Rotation => NEXT_ROTATION[rotation];

const isSideways = (rotation: Rotation): boolean => rotation === 90 || rotation === 270;

export type { Rotation };
export { isSideways, ROTATION_CLASS_NAME, rotateClockwise };
